/* eslint-disable relay/unused-fields */
import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { SearchResultListToggle } from "scmp-app/components/search/search-result-panel/search-result-list/search-result-list-toggle";
import type { SectionEdge } from "scmp-app/components/search/types";
import { checkIfNewsSectionInFirstIndex } from "scmp-app/lib/section";
import type { sectionSearchResultListSectionSearchConnection$key } from "scmp-app/queries/__generated__/sectionSearchResultListSectionSearchConnection.graphql";

import { Container, SectionSectionTitle, StyledSectionSearchResultListItem } from "./styles";

export type Props = {
  reference: sectionSearchResultListSectionSearchConnection$key;
};

export const SectionSearchResultList: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const sections = useFragment<sectionSearchResultListSectionSearchConnection$key>(
    graphql`
      fragment sectionSearchResultListSectionSearchConnection on SectionSearchConnection {
        edges {
          node {
            score
            content {
              entityId
              fullSectionPath {
                ...helpersCheckIfNewsSectionInFirstIndexSection
                name
              }
              ...sectionSearchResultListItemSection
            }
          }
        }
      }
    `,
    reference_,
  );

  const handleRenderSuggestedSectionItem = (edge?: SectionEdge) => {
    if (!edge?.node?.content?.entityId) return null;
    return (
      <StyledSectionSearchResultListItem
        key={edge.node.content.entityId}
        reference={edge.node.content}
      />
    );
  };

  const [isExpand, toggleIsExpand] = useToggle();

  // Check if full section path more than one items or is not news section
  const sanitizedSections = sections.edges?.filter(
    edge =>
      edge.node.content?.fullSectionPath?.length &&
      (edge.node.content?.fullSectionPath?.length > 1 ||
        !checkIfNewsSectionInFirstIndex(edge?.node?.content?.fullSectionPath?.[0], 0)),
  );

  return sanitizedSections.length > 0 ? (
    <Container>
      <SectionSectionTitle>Section:</SectionSectionTitle>
      {isExpand
        ? sanitizedSections?.map(node => handleRenderSuggestedSectionItem(node))
        : handleRenderSuggestedSectionItem(sanitizedSections?.[0])}
      {sanitizedSections.length > 1 && (
        <SearchResultListToggle
          isExpand={isExpand}
          onClick={() => toggleIsExpand()}
          toggleMessage={{
            after: "Show less",
            before: "Show all sections",
          }}
        />
      )}
    </Container>
  ) : null;
};

SectionSearchResultList.displayName = "SectionSearchResultList";
